// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Select from "../../html/Select.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../packages/util/lib/DateTime.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import BackArrowSvg from "static/icons/back-arrow.svg";

const monthSelectOptions = {
  hd: {
    value: 1,
    text: "Январь"
  },
  tl: {
    hd: {
      value: 2,
      text: "Февраль"
    },
    tl: {
      hd: {
        value: 3,
        text: "Март"
      },
      tl: {
        hd: {
          value: 4,
          text: "Апрель"
        },
        tl: {
          hd: {
            value: 5,
            text: "Май"
          },
          tl: {
            hd: {
              value: 6,
              text: "Июнь"
            },
            tl: {
              hd: {
                value: 7,
                text: "Июль"
              },
              tl: {
                hd: {
                  value: 8,
                  text: "Август"
                },
                tl: {
                  hd: {
                    value: 9,
                    text: "Сентябрь"
                  },
                  tl: {
                    hd: {
                      value: 10,
                      text: "Октябрь"
                    },
                    tl: {
                      hd: {
                        value: 11,
                        text: "Ноябрь"
                      },
                      tl: {
                        hd: {
                          value: 12,
                          text: "Декабрь"
                        },
                        tl: /* [] */0
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

const yearSelectOptions = {
  hd: {
    value: 1980,
    text: "1980"
  },
  tl: {
    hd: {
      value: 1981,
      text: "1981"
    },
    tl: {
      hd: {
        value: 1982,
        text: "1982"
      },
      tl: {
        hd: {
          value: 1983,
          text: "1983"
        },
        tl: {
          hd: {
            value: 1984,
            text: "1984"
          },
          tl: {
            hd: {
              value: 1985,
              text: "1985"
            },
            tl: {
              hd: {
                value: 1986,
                text: "1986"
              },
              tl: {
                hd: {
                  value: 1987,
                  text: "1987"
                },
                tl: {
                  hd: {
                    value: 1988,
                    text: "1988"
                  },
                  tl: {
                    hd: {
                      value: 1989,
                      text: "1989"
                    },
                    tl: {
                      hd: {
                        value: 1990,
                        text: "1990"
                      },
                      tl: {
                        hd: {
                          value: 1991,
                          text: "1991"
                        },
                        tl: {
                          hd: {
                            value: 1992,
                            text: "1992"
                          },
                          tl: {
                            hd: {
                              value: 1993,
                              text: "1993"
                            },
                            tl: {
                              hd: {
                                value: 1994,
                                text: "1994"
                              },
                              tl: {
                                hd: {
                                  value: 1995,
                                  text: "1995"
                                },
                                tl: {
                                  hd: {
                                    value: 1996,
                                    text: "1996"
                                  },
                                  tl: {
                                    hd: {
                                      value: 1997,
                                      text: "1997"
                                    },
                                    tl: {
                                      hd: {
                                        value: 1998,
                                        text: "1998"
                                      },
                                      tl: {
                                        hd: {
                                          value: 1999,
                                          text: "1999"
                                        },
                                        tl: {
                                          hd: {
                                            value: 2000,
                                            text: "2000"
                                          },
                                          tl: {
                                            hd: {
                                              value: 2001,
                                              text: "2001"
                                            },
                                            tl: {
                                              hd: {
                                                value: 2002,
                                                text: "2002"
                                              },
                                              tl: {
                                                hd: {
                                                  value: 2003,
                                                  text: "2003"
                                                },
                                                tl: {
                                                  hd: {
                                                    value: 2004,
                                                    text: "2004"
                                                  },
                                                  tl: {
                                                    hd: {
                                                      value: 2005,
                                                      text: "2005"
                                                    },
                                                    tl: {
                                                      hd: {
                                                        value: 2006,
                                                        text: "2006"
                                                      },
                                                      tl: {
                                                        hd: {
                                                          value: 2007,
                                                          text: "2007"
                                                        },
                                                        tl: {
                                                          hd: {
                                                            value: 2008,
                                                            text: "2008"
                                                          },
                                                          tl: {
                                                            hd: {
                                                              value: 2009,
                                                              text: "2009"
                                                            },
                                                            tl: {
                                                              hd: {
                                                                value: 2010,
                                                                text: "2010"
                                                              },
                                                              tl: {
                                                                hd: {
                                                                  value: 2011,
                                                                  text: "2011"
                                                                },
                                                                tl: {
                                                                  hd: {
                                                                    value: 2012,
                                                                    text: "2012"
                                                                  },
                                                                  tl: {
                                                                    hd: {
                                                                      value: 2013,
                                                                      text: "2013"
                                                                    },
                                                                    tl: {
                                                                      hd: {
                                                                        value: 2014,
                                                                        text: "2014"
                                                                      },
                                                                      tl: {
                                                                        hd: {
                                                                          value: 2015,
                                                                          text: "2015"
                                                                        },
                                                                        tl: {
                                                                          hd: {
                                                                            value: 2016,
                                                                            text: "2016"
                                                                          },
                                                                          tl: {
                                                                            hd: {
                                                                              value: 2017,
                                                                              text: "2017"
                                                                            },
                                                                            tl: {
                                                                              hd: {
                                                                                value: 2018,
                                                                                text: "2018"
                                                                              },
                                                                              tl: {
                                                                                hd: {
                                                                                  value: 2019,
                                                                                  text: "2019"
                                                                                },
                                                                                tl: {
                                                                                  hd: {
                                                                                    value: 2020,
                                                                                    text: "2020"
                                                                                  },
                                                                                  tl: {
                                                                                    hd: {
                                                                                      value: 2021,
                                                                                      text: "2021"
                                                                                    },
                                                                                    tl: {
                                                                                      hd: {
                                                                                        value: 2022,
                                                                                        text: "2022"
                                                                                      },
                                                                                      tl: {
                                                                                        hd: {
                                                                                          value: 2023,
                                                                                          text: "2023"
                                                                                        },
                                                                                        tl: {
                                                                                          hd: {
                                                                                            value: 2024,
                                                                                            text: "2024"
                                                                                          },
                                                                                          tl: {
                                                                                            hd: {
                                                                                              value: 2025,
                                                                                              text: "2025"
                                                                                            },
                                                                                            tl: {
                                                                                              hd: {
                                                                                                value: 2026,
                                                                                                text: "2026"
                                                                                              },
                                                                                              tl: {
                                                                                                hd: {
                                                                                                  value: 2027,
                                                                                                  text: "2027"
                                                                                                },
                                                                                                tl: {
                                                                                                  hd: {
                                                                                                    value: 2028,
                                                                                                    text: "2028"
                                                                                                  },
                                                                                                  tl: {
                                                                                                    hd: {
                                                                                                      value: 2029,
                                                                                                      text: "2029"
                                                                                                    },
                                                                                                    tl: {
                                                                                                      hd: {
                                                                                                        value: 2030,
                                                                                                        text: "2030"
                                                                                                      },
                                                                                                      tl: {
                                                                                                        hd: {
                                                                                                          value: 2031,
                                                                                                          text: "2031"
                                                                                                        },
                                                                                                        tl: {
                                                                                                          hd: {
                                                                                                            value: 2032,
                                                                                                            text: "2032"
                                                                                                          },
                                                                                                          tl: {
                                                                                                            hd: {
                                                                                                              value: 2033,
                                                                                                              text: "2033"
                                                                                                            },
                                                                                                            tl: {
                                                                                                              hd: {
                                                                                                                value: 2034,
                                                                                                                text: "2034"
                                                                                                              },
                                                                                                              tl: /* [] */0
                                                                                                            }
                                                                                                          }
                                                                                                        }
                                                                                                      }
                                                                                                    }
                                                                                                  }
                                                                                                }
                                                                                              }
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

function generateYearOptions(tillExactYear) {
  return Belt__Belt_List.reverse(Belt__Belt_List.keep(yearSelectOptions, (function (option) {
                    return option.value <= tillExactYear;
                  })));
}

function make(value) {
  return function (onChange) {
    return function (displayYearOnlyOpt) {
      const displayYearOnly = displayYearOnlyOpt !== undefined ? displayYearOnlyOpt : false;
      return function (isBirthDayOpt) {
        const isBirthDay = isBirthDayOpt !== undefined ? isBirthDayOpt : false;
        return function (tillExactYearOpt) {
          const tillExactYear = tillExactYearOpt !== undefined ? tillExactYearOpt : 2034;
          const year = value[1];
          const month = value[0];
          const currentMonth = DateTime.month(DateTime.local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined));
          const currentYear = DateTime.year(DateTime.local(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined));
          const onArrowClickHandler = function (direction) {
            if (displayYearOnly) {
              const year$1 = year + direction | 0;
              return Curry._2(onChange, month, year$1);
            }
            const month$1 = month + direction | 0;
            if (month$1 > 12) {
              return Curry._2(onChange, 1, year + 1 | 0);
            } else if (month$1 < 1) {
              return Curry._2(onChange, 12, year - 1 | 0);
            } else {
              return Curry._2(onChange, month$1, year);
            }
          };
          const yearSelectOptions = generateYearOptions(tillExactYear);
          return JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("button", {
                              children: JsxRuntime.jsx(BackArrowSvg, {}),
                              disabled: year === 1971,
                              type: "button",
                              onClick: (function (param) {
                                  onArrowClickHandler(-1);
                                })
                            }),
                        displayYearOnly ? JsxRuntime.jsx(Buhta_cabinet__Select.make, {
                                className: "w-21 grow",
                                options: yearSelectOptions,
                                nowrap: true,
                                selectedOption: Buhta_cabinet__Select.findInList(yearSelectOptions, year),
                                onChange: (function (option) {
                                    Belt__Belt_Option.mapWithDefault(option, undefined, (function (option) {
                                            Curry._2(onChange, month, option.value);
                                          }));
                                  }),
                                whiteMode: false,
                                selectedOptionClassName: "!justify-center"
                              }) : JsxRuntime.jsxs(React.Fragment, {
                                children: [
                                  JsxRuntime.jsx(Buhta_cabinet__Select.make, {
                                        className: "w-21 grow",
                                        options: monthSelectOptions,
                                        nowrap: true,
                                        selectedOption: Buhta_cabinet__Select.findInList(monthSelectOptions, month),
                                        onChange: (function (option) {
                                            Belt__Belt_Option.mapWithDefault(option, undefined, (function (option) {
                                                    Curry._2(onChange, option.value, year);
                                                  }));
                                          }),
                                        whiteMode: false,
                                        selectedOptionClassName: "!justify-center"
                                      }),
                                  JsxRuntime.jsx(Buhta_cabinet__Select.make, {
                                        className: "w-21 grow",
                                        options: yearSelectOptions,
                                        nowrap: true,
                                        selectedOption: Buhta_cabinet__Select.findInList(yearSelectOptions, year),
                                        onChange: (function (option) {
                                            Belt__Belt_Option.mapWithDefault(option, undefined, (function (option) {
                                                    Curry._2(onChange, month, option.value);
                                                  }));
                                          }),
                                        whiteMode: false,
                                        selectedOptionClassName: "!justify-center"
                                      })
                                ]
                              }),
                        JsxRuntime.jsx("button", {
                              children: JsxRuntime.jsx(BackArrowSvg, {}),
                              className: "rotate-180",
                              disabled: isBirthDay ? year >= currentYear && month >= currentMonth : year === tillExactYear,
                              type: "button",
                              onClick: (function (param) {
                                  onArrowClickHandler(1);
                                })
                            })
                      ],
                      className: "flex"
                    });
        };
      };
    };
  };
}

function CalendayMonthSelect(Props) {
  return Curry._3(make(Props.value)(Props.onChange), Props.displayYearOnly, Props.isBirthDay, Props.tillExactYear);
}

const make$1 = CalendayMonthSelect;

export {
  monthSelectOptions ,
  yearSelectOptions ,
  generateYearOptions ,
  make$1 as make,
}
/* Buhta_cabinet__Select Not a pure module */
